import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { showVmsManagementContractLink } from '../constants/vmsAccessMatrix';
import { getVmsDefaultLandingPath } from '../utils/vmsRole';
import { PageLoader } from './LoadingStates';

/** VMS contract definition routes (see showVmsManagementContractLink). */
const VmsLegalOrAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <PageLoader message="Loading..." />;
  }
  if (!showVmsManagementContractLink(user)) {
    return <Navigate to={getVmsDefaultLandingPath(user)} replace />;
  }
  return <>{children}</>;
};

export default VmsLegalOrAdminRoute;
